// API base URL: REACT_APP_API_BASE_URL wins when set (see .env.example).
// Otherwise production builds use the live API and `npm start` uses the local one.
const PRODUCTION_API_BASE_URL = "https://projects-kart-server.onrender.com";
const LOCAL_API_BASE_URL = "http://localhost:5267";
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "production" ? PRODUCTION_API_BASE_URL : LOCAL_API_BASE_URL);
export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000;
export const MAX_FILE_SIZE =
  parseInt(process.env.REACT_APP_MAX_FILE_SIZE) || 5242880; // 5MB
export const ALLOWED_FILE_TYPES =
  process.env.REACT_APP_ALLOWED_FILE_TYPES?.split(',') || [
    'jpg',
    'jpeg',
    'png',
    'pdf',
  ];

// Local storage keys
export const AUTH_TOKEN = 'token';
export const USER_NAME = 'user_name';
export const USER_GITHUB_USERNAME = 'user_github_username';
export const USER_ID = 'user_id';
export const USER_PHONE = 'user_phone';
export const USER_ROLE = 'user_role';
export const USER_STATUS = 'user_status';
export const USER_GITHUB_PROFILE = 'user_github_profile';

// Security configurations
export const TOKEN_EXPIRY_HOURS =
  parseInt(process.env.REACT_APP_TOKEN_EXPIRY_HOURS) || 24;
export const MAX_LOGIN_ATTEMPTS =
  parseInt(process.env.REACT_APP_MAX_LOGIN_ATTEMPTS) || 5;

// Application settings
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
export const ENABLE_ANALYTICS =
  process.env.REACT_APP_ENABLE_ANALYTICS === 'true';
export const ENABLE_DEBUG = process.env.REACT_APP_ENABLE_DEBUG === 'true';

export const PAYMENT_METHOD_GETWAY = "QR-CODE" ;
